import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allApiKeys: [''],
  apiKey: '',
  userApiKey: [''],
  newApiKey: '',
  updatedApiKey: '',
  deletedApiKey: '',
  toggleCreateApiKey: false,
  isLoading: false,
  error: null,
};

const apiKeySlice = createSlice({
  name: 'apiKey',
  initialState,
  reducers: {
    start: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    setReducerError: (state, action) => {
      state.error = 'ApiKeys were not Loaded';
    },
    setAllApiKeys: (state, action) => {
      state.allApiKeys = action.payload;
      state.error = null;
    },
    setApiKey: (state, action) => {
      state.apiKey = action.payload;
      state.error = null;
    },
    setUserApiKey: (state, action) => {
      state.userApiKey = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setNewApiKey: (state, action) => {
      state.newApiKey = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setUpdatedApiKey: (state, action) => {
      state.updatedApiKey = action.payload;
      state.error = null;
    },
    setDeletedApiKey: (state, action) => {
      state.deletedApiKey = action.payload;
      state.error = null;
    },
    setToggleCreateApiKey: (state, action) => {
      state.toggleCreateApiKey = !state.toggleCreateApiKey;
    },
    setResetApiKey: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setAllApiKeys,
  setApiKey,
  setUserApiKey,
  setNewApiKey,
  setUpdatedApiKey,
  setDeletedApiKey,
  setToggleCreateApiKey,
  setResetApiKey,
} = apiKeySlice.actions;

export default apiKeySlice.reducer;
